import { sendVerifyEmail } from "@Http/send_verify_email";
import { useMutation } from "@tanstack/react-query";
import { MutationError } from "@Types/index";
import { toast } from "react-toastify";
import { CurrentUser } from "src/App";

export const useVerifyEmail = () => {
  const mutation = useMutation<
    string,
    MutationError,
    { firebaseUser: CurrentUser }
  >(sendVerifyEmail(), {
    onSuccess: () => {
      toast.success("Verification email sent!", { position: "top-center" });
    },
    onError: (error) => {
      toast.error(error?.message?.replace("Firebase: ", ""), {
        position: "top-center",
      });
    },
  });
  return {
    sendVerifyEmail: mutation.mutateAsync,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};
